module.exports = __webpack_public_path__ + "static/media/business.15b47059.jpg";